// extracted by mini-css-extract-plugin
export default {"productDescription":"Mba-z","featuredDescription":"Nba-z","description":"Oba-z","more":"Pba-z","descriptionSku":"Qba-z"};